module.exports = __webpack_public_path__ + "static/img/temp.753a1334.png";